import styles from './style.module.scss';
import errorImg from '@/assets/images/res/empty.png';

const ErrorPage = (props) => {
    return (
        <div className={styles.errorPage}>
            <div className={styles.errorImg}>
                <img src={errorImg} alt="" />
            </div>
            <div className={styles.errorTitle}>{props?.title || '结果生成失败，请重新生成...'}</div>
            <div className={styles.button} onClick={props?.onClick}>
                {props?.buttonText || '重新生成'}
            </div>
        </div>
    );
};
export default ErrorPage;
